<script setup lang="ts">
import { digitsOnly as vDigitsOnly } from '@/common/directives/digitsOnly'

defineProps<{
  workExperienceYear: string
  workExperienceShortDescription: string
  workExperienceLongDescription: string
  disabled: boolean
}>()

const emit = defineEmits<{
  'update:workExperienceYear': [value: string]
  'update:workExperienceShortDescription': [value: string]
  'update:workExperienceLongDescription': [value: string]
  workExperienceLongInputChange: []
}>()

function onWorkExperienceYearInput(event: Event): void {
  emit('update:workExperienceYear', (event.target as HTMLInputElement).value)
}

function onWorkExperienceShortDescriptionInput(event: Event): void {
  emit('update:workExperienceShortDescription', (event.target as HTMLInputElement).value)
}

function onWorkExperienceLongDescriptionInput(event: Event): void {
  emit('update:workExperienceLongDescription', (event.target as HTMLTextAreaElement).value)
}
</script>

<template>
  <div class="form-field requiredinput">
    <label for="WorkExperienceYearInput">What year did you complete the work experience / industry-based certification?</label>
    <input
      id="WorkExperienceYearInput"
      v-digits-only
      :value="workExperienceYear"
      inputmode="numeric"
      pattern="[0-9][0-9][0-9][0-9]"
      class="form-control"
      :disabled="disabled"
      @input="onWorkExperienceYearInput"
    >
  </div>

  <div class="form-field requiredinput">
    <label for="WorkExperienceShortInput">In as few words as possible, what was the work experience / industry-based certification?</label>
    <input
      id="WorkExperienceShortInput"
      :value="workExperienceShortDescription"
      class="form-control"
      maxlength="50"
      :disabled="disabled"
      @input="onWorkExperienceShortDescriptionInput"
    >
  </div>

  <div class="form-field requiredinput hidden">
    <label for="WorkExperienceLongInput">How do you think the work experience / industry-based certification is relevant to the subjects you are requesting credit for?</label>
    <textarea
      id="WorkExperienceLongInput"
      :value="workExperienceLongDescription"
      class="form-control"
      rows="10"
      :disabled="disabled"
      @input="onWorkExperienceLongDescriptionInput"
      @change="emit('workExperienceLongInputChange')"
    ></textarea>
  </div>
</template>
